
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.068 10.996a.012.012 0 00.009.004c.005 0 .01.003.011.008a1.5 1.5 0 002.445.58c.307-.292.665-.588 1.089-.588h5.756c.424 0 .782.296 1.089.588a1.5 1.5 0 002.445-.58.011.011 0 01.01-.008.011.011 0 00.01-.005l.916-1.466a1 1 0 00.152-.53V6.65c0-.146-.032-.291-.095-.424l-1.242-2.651A1 1 0 0017.757 3H11.78a1 1 0 00-.624.22l-3.94 3.15a.999.999 0 01-.154.102L5.53 7.29A1 1 0 005 8.171v1.29a1 1 0 00.27.685l.798.85zm3.714-5.59l1.506-1.286a.5.5 0 01.325-.12h2.53a.5.5 0 01.5.5v1.286a.5.5 0 01-.5.5h-4.037a.5.5 0 01-.324-.88zm5.932.38V4.5a.5.5 0 01.5-.5h1.325a.5.5 0 01.453.288l.603 1.285a.5.5 0 01-.453.713h-1.928a.5.5 0 01-.5-.5z","fill":"currentColor"}})])
          )
        }
      }
    